module.exports = __webpack_public_path__ + "static/media/apple.98c922e3.png";